import React from 'react'
import { PropTypes } from 'prop-types';

import { StyledBadgeSmall } from './styled'

const BadgeSmall = ({ children, ...props}) => {
  return <StyledBadgeSmall {...props} >{children}</StyledBadgeSmall>
}

BadgeSmall.propTypes = {
  color: PropTypes.string,
  background: PropTypes.string,
  borderColor: PropTypes.string
}

export default BadgeSmall;